import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { ISearchLabs, ISearchLabsParameters } from 'app/models/searchLabs/searchLabs';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json'
  })
};

@Injectable({
  providedIn: 'root',
})

export class SearchLabsService {
  private api: string = environment.publicApi + 'SearchLabs/';
  private reportApi: string = environment.privateApi + 'Reports/';
  constructor(private http: HttpClient){}

  getSearchLabs(searchParameters: ISearchLabsParameters): Observable<ISearchLabs[]> {
    return this.http.post<ISearchLabs[]> (this.api + 'GetSearchLabs',searchParameters,  httpOptions)
  }

  getSearchFoaReport(appId: number, type: string): Observable<Blob>{
    return this.http.get<Blob>(this.api + 'getSearchFoaReport/' + appId + '/' + type, 
      { responseType: 'blob' as 'json' });
  }
}
